/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');
const { updateGraphItemsGeometry } = require('../utils/shapes');

const DIRECTION = {
	'command.server.DeleteCellsCommand': { horizontal: 'left', vertical: 'up' },
	'command.server.InsertCellsCommand': { horizontal: 'right', vertical: 'bottom' }
};
const shiftedRange = (range) => {
	range = range.copy();
	range.shiftToSheet();
	return range;
};
const colInfo = (range) => ({ type: 'cols', start: range.getColumnString(range.getX1()), count: range.getWidth() });
const rowInfo = (range) => ({ type: 'rows', start: range.getY1() + 1, count: range.getHeight() });
const cellsInfo = (range) => ({ type: 'cells', range: range.toString() });
const createInfo = (type, range) => {
	switch (type) {
		case 'rows':
			return rowInfo(range);
		case 'columns':
			return colInfo(range);
		case 'cellshorizontal':
		case 'cellsvertical':
			return cellsInfo(range);
		default:
	}
	return undefined;
};
const getDirection = (type) => {
	const isVertical = type === 'cellsvertical';
	return (cmdname) => {
		const direction = DIRECTION[cmdname];
		return isVertical ? direction.vertical : direction.horizontal;
	};
};

class InsertDeleteCommand extends RequestCommand {
	constructor(range, type, graph, undoCmd) {
		super(range.sheet);
		this.getDirection = getDirection(type);
		this.info = createInfo(type, shiftedRange(range));
		this.info.direction = this.getDirection(this.name);
		this.undoCmd = undoCmd;
		this.undoInfo = undefined;
		this.saveSelection([range]);
		this.updateShapes = updateGraphItemsGeometry(graph, this._selection[0]);
	}

	// note: this is called on undo too -> maybe send old shapes with undoInfo
	createRequest(info, cmd) {
		if (info) {
			const request = super.createRequest(info, cmd);
			// add updated shapes:
			request.info.shapes = this.updateShapes(request);
			return request;
		}
		return undefined;
	}
	getExecuteRequest() {
		return this.createRequest(this.info);
	}
	getRedoRequest() {
		return this.createRequest(this.info);
	}
	getUndoRequest() {
		return this.createRequest(this.undoInfo, this.undoCmd);
	}
	handleResult(result) {
		// successful, so
		if (!this.undoInfo) {
			this.undoInfo = { ...this.info };
			this.undoInfo.undo = result.undo;
			// this.undoInfo.shapes = this.shapes;
			if (this.undoInfo.type === 'cells') {
				this.undoInfo.direction = this.getDirection(this.undoCmd);
			}
		}
	}
}
class InsertCellsCommand extends InsertDeleteCommand {
	constructor(range, type, graph) {
		super(range, type, graph, 'command.server.DeleteCellsCommand');
	}
}
class DeleteCellsCommand extends InsertDeleteCommand {
	constructor(range, type, graph) {
		super(range, type, graph, 'command.server.InsertCellsCommand');
	}
}
module.exports = {
	DeleteCellsCommand,
	InsertCellsCommand
};
